import { Network } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  onCreate?: () => void;
}

const BlockchainNetworkEmpty = ({ onCreate }: Props) => {
  return (
    <div className="rounded-2xl border border-dashed bg-card py-20">
      <div className="mx-auto flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
          <Network className="h-10 w-10 text-primary" />
        </div>

        <h3 className="text-xl font-semibold">No Blockchain Networks</h3>

        <p className="mt-2 text-sm text-muted-foreground">
          There are no blockchain networks matching your search or filters.
        </p>

        <Button className="mt-8" onClick={onCreate}>
          Add Blockchain Network
        </Button>
      </div>
    </div>
  );
};

export default BlockchainNetworkEmpty;
